export function getFinanceEmployerTypes(t: (string) => string) {
    return [
        {type: "consulting", value: t("profile.form.employertype.consulting")},
        {type: "end-customer", value: t("profile.form.employertype.endcustomer")}
    ];
}

export function getLegalEmployerTypes(t: (string) => string) {
    return [
        {type: "consulting", value: t("profile.form.employertype.consulting")},
        {type: "end-customer", value: t("profile.form.employertype.endcustomer")}
    ];
}

export function getTechEmployerTypes(t: (string) => string) {
    return [
        {type: "consulting", value: t("profile.form.employertype_tech.consulting")},
        {type: "end-customer", value: t("profile.form.employertype_tech.endcustomer")},
    ];
}

export function prettyEmployerTypes(ets: string[] | null, tech: boolean, t: (string) => string): string {
    if (ets == null) return "";
    if (tech)
        return ets.map(et => t("profile.form.employertype_tech." + et.replace('-', ''))).join(", ");
    return ets.map(et => t("profile.form.employertype." + et.replace('-', ''))).join(" & ");
}

export function prettyEmployerType(et: string | null, tech: boolean, t: (string) => string): string {
    if (et== null) return "";
    if (tech)
        return t("profile.form.employertype_tech." + et.replace('-', ''));
    return t("profile.form.employertype." + et.replace('-', ''));
}
